export const serviceBlockTokens = {
  colors: {
    background: "transparent",
  },
  spacing: {
    none: 0,
    sm: 16,
    default: 28,
    md: 36,
    lg: 48,
  },
  classes: {
    point: "slide-down",
    pointTitle: "text-neutral-900",
  },
  layout: "responsive",
  variant: "section",
} as const;

export type ServiceBlockSpacingToken = keyof typeof serviceBlockTokens.spacing;
